export class ImageWorkerImage {
    constructor(manager, id, src) {
        this.manager = manager;
        this.id = id;
        this.src = src;
    }
    set onError(f) {
        this._onError = f;
    }
    set onLoad(f) {
        this._onLoad = f;
    }
    cancel() {
        this.manager.cancel(this);
    }
    load(info) {
        if (this._onLoad) {
            this._onLoad(info);
        }
    }
    error(info) {
        if (this._onError) {
            this._onError(info);
        }
    }
}
//# sourceMappingURL=ImageWorkerImage.js.map